var t = function(n) {
  return n.filter(function(u, e) {
    return n.indexOf(u) === e;
  });
};
export {
  t as u
};
